'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { CatChip } from '@blocks-react/components/Chip';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './DealerLocatorFiltersServiceOfferingsChips.module.scss';
import { v4 as uuid } from 'uuid';
export const DealerLocatorFiltersServiceOfferingsChips = ({ options }) => {
    const { setValue, watch } = useFormContext();
    const optionsValues = watch('options');
    const handleChipClicked = useCallback((index) => {
        const newOptions = [...watch('options')];
        newOptions[index] = !newOptions[index];
        setValue('options', newOptions, { shouldDirty: true });
    }, [watch, setValue]);
    return (_jsx("div", { className: styles['chips-container'], children: optionsValues.map((optionValue, index) => (_jsx(CatChip, { className: "mr-3", isActive: !!optionValue, onBlChipSelect: () => handleChipClicked(index), children: options[index] }, `chip-${uuid()}`))) }));
};
